import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Row, Col, Form } from "react-bootstrap";
import "./add-affiliates.css";
import validator from "validator";
import DataTable from "react-data-table-component";
import { getAffiliatesWithPagination, saveAffiliate } from "../../../axios/affiliate.axios";
import LoadingOverlay from "react-loading-overlay";
import { CopyToClipboard } from "react-copy-to-clipboard";
const columns = [
  {
    name: "Affiliate Name",
    selector: (row) => row.name,
    sortable: true,
    width: "200px",
  },
  {
    name: "Affiliate Website",
    selector: (row) => row.website,
    sortable: true,
    width: "350px",
  },
  {
    name: "Affiliate ID",
    selector: (row) => row.id,
    sortable: true,
    width: "300px",
  },
  {
    name: "Affiliate URL",
    selector: (row) => row.url,
    sortable: true,
    width: "350px",
  },
  {
    name: "Hits",
    selector: (row) => (row.hits ? row.hits.length : 0),
    sortable: true,
    width: "220px",
  },
  {
    name: "Sign Ups",
    selector: (row) => (row.users ? row.users.length : 0),
    sortable: true,
    width: "220px",
  },
  {
    name: "Action",
    selector: (row) => row.action,
    sortable: true,
  },
];

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const AddAffiliates = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [copyText, setcopyText] = useState("");
  const [errorMessage, setErrorMessage] = useState({
    name: "",
    website: "",
  });
  const [input, setInput] = useState({
    name: "",
    website: "",
    url: "",
  });
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleSave = async (event) => {
    event.preventDefault();
    try {
      if (input.name && input.website) {
        let newAffiliate = await saveAffiliate(undefined, input);
        if (newAffiliate) {
          setInput({
            ...input,
            url: newAffiliate.url,
          });
          setcopyText(newAffiliate.url);
          setIsOpen(true);
          fillRows();
        }
      } else {
        alert("Please fill out the form");
      }
    } catch (error) {}
  };

  const isNotEmpty = (string) => {
    return !validator.isEmpty(string);
  };

  const fillRows = async () => {
    setLoading(true);
    try {
      let affiliateRows = await getAffiliatesWithPagination(undefined, page, limit);
      setLoading(false);
      if (affiliateRows?.status) {
        setTotal(affiliateRows?.pagination?.totalRows || 0);
        affiliateRows = affiliateRows?.data?.map((row, index) => {
          row.action = (
            <div className="act_but">
              <CopyToClipboard text={row.url}>
                <button
                  type="button"
                  className="edit_but"
                  id={row.id}
                  data-id={row.id}
                  onClick={() => {
                    changeStatus(row.id, !row.status);
                  }}
                >
                  Copy
                </button>
              </CopyToClipboard>
              {/* <button type="button" className="edit_but" id={row.id} data-id={row.id} onClick ={()=>{changeStatus(row.id,!row.status)}}>
            {row.status ? "Deactivate": "Activate"}
          </button> */}
            </div>
          );
          return row;
        });

        setTableData(affiliateRows);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fillRows();
  }, [ page, limit]);
  const changeStatus = (event) => {};
  const handleInputchange = (event) => {
    setInput({
      ...input,
      [event.target.name]: event.target.value,
    });
    if (isNotEmpty(event.target.value)) {
      setErrorMessage({
        ...errorMessage,
        [event.target.name]: "",
      });
    } else {
      setErrorMessage({
        ...errorMessage,
        [event.target.name]: "Please add some text",
      });
    }
  };

  return (
    // <LoadingOverlay active={false} spinner text="loading...">
    <LoadingOverlay active={loading} spinner text="loading...">
    <div className="right_cont">
      <div className="right_banner_banner_cnt">
        <div className="travel_deals_admin">
          {/* <h2>Hello, Admin!</h2> */}

          <div className="add_certificate">
            <h3>Affiliate Name</h3>
            <div className="addcert_box1">
              <Row>
                <Col lg="12" md="12" sm="12">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter Affiliate Name"
                      className="text_link"
                      value={input.name}
                      onChange={(event) => {
                        handleInputchange(event);
                      }}
                    />
                    <span className="text-danger">{errorMessage.name}</span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>

          <div className="add_certificate">
            <h3>Affiliate Website URL</h3>
            <div className="addcert_box1">
              <Row>
                <Col lg="12" md="12" sm="12">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="text"
                      name="website"
                      placeholder="Enter Affiliate Website URL"
                      className="text_link"
                      value={input.website}
                      onChange={(event) => {
                        handleInputchange(event);
                      }}
                    />
                    <span className="text-danger">{errorMessage.website}</span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>
          <div className="sub_but">
            <button
              type="button"
              onClick={handleSave}
              className="add_but submit_buttt mt-0"
            >
              Generate Affiliate URL
            </button>
          </div>
          {isOpen && (
            <div className="d-flex justify-content-between mt-5">
              <div className="label_text">
                <p>{input.url}</p>
              </div>
              <div className="copy_but">
                <CopyToClipboard text={copyText}>
                  <button type="button" className="copy_but">
                    COPY
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          )}
        </div>
        <div className="affiliate_list user_added">
          <h2>Affiliate Lists</h2>
          

          <DataTable
            columns={columns}
            data={tableData}
            pagination
            striped
            responsive
            customStyles={customStyles}
            subHeaderAlign="right"
            subHeaderWrap
            //paginationDefaultPage={page}
             paginationServer
            paginationTotalRows={total}
            paginationPerPage={limit}
            //paginationTotalRows={pagination.totalRows}
            //paginationPerPage={limit}
            paginationRowsPerPageOptions={[10, 15, 20, 40]}
            onChangePage={(newPage) => setPage(newPage)}
            onChangeRowsPerPage={(newLimit) => {
                setLimit(newLimit);
                setPage(1);
            }}
            //onChangeRowsPerPage={handlePerRowsChange}
            //onChangePage={changePage}
            //progressComponent={<CustomLoader />}
            //noDataComponent={<EmptyDataLoader />}
          />
        </div>
      </div>
    </div>
   </LoadingOverlay>
  );
};
export default AddAffiliates;
